import React, { Fragment, useEffect, useRef, useState } from "react";
import { NumberTool, StringTool } from "../../tool";
import style from "./monthPicker.css"

interface MonthPickerProps {
  disabled?: boolean
  clearable?: boolean
  value?: Date
  onChange?: (value: any) => void
  minDate?: Date
  maxDate?: Date
  renderView: (inputProps: React.HtmlHTMLAttributes<HTMLInputElement>, clearButtonProps: React.ButtonHTMLAttributes<HTMLButtonElement>) => any
};

const MonthPicker = (props: MonthPickerProps) => {


  const { value, minDate, maxDate, onChange } = props

  const [valueState, setValueState] = useState(null as unknown | Date)
  const [showCalendar, setShowCalendar] = useState(false)
  const [showYearPicker, setShowYearPicker] = useState(false)
  const [month, setMonth] = useState(() => {
    return new Date().getMonth()
  })
  const [year, setYear] = useState(() => {
    return new Date().getFullYear()
  })
  const [months, setMonths] = useState([] as Array<any>)
  const [years, setYears] = useState([] as Array<any>)

  const yearRef = useRef(null as any)

  useEffect(() => {
    setValueState(value)
  }, [value])

  // useEffect(() => {
  //   let firstDate = new Date(year, month, 1);
  //   let firstDay = firstDate.getDay()
  //   let lastDate = new Date(year, month + 1, 0);
  //   let lastDateInMonth = lastDate.getDate()
  //   let lastDay = lastDate.getDay()
  //   let preArray = []
  //   let afterArray = []
  //   for (let i = 0; i < firstDay; i++) {
  //     preArray.push({
  //       disable: true,
  //       value: null,
  //       id: i - 40,
  //       isActive: false,
  //       isCurrent: false
  //     })
  //   }
  //   for (let j = 6; j > lastDay; j--) {
  //     afterArray.push({
  //       value: null,
  //       disable: true,
  //       id: j + 40,
  //       isActive: false,
  //       isCurrent: false
  //     })
  //   }
  //   let days = Array.from({ length: lastDateInMonth }, (_, i) => ({
  //     disable: false,
  //     value: i + 1,
  //     isActive: false,
  //     isCurrent: false
  //   }))
  //   let arr = [...preArray, ...days, ...afterArray]
  //   let minYear = minDate?.getFullYear() || 0
  //   let minMonth = minDate?.getMonth() || 0
  //   let minDate1 = minDate?.getDate() || 0

  //   let maxYear = maxDate?.getFullYear() || 0
  //   let maxMonth = maxDate?.getMonth() || 0
  //   let maxDate1 = maxDate?.getDate() || 0

  //   arr.forEach(d => {
  //     let disable = false
  //     if (!d.disable) {
  //       if (minDate) {
  //         if (year < minYear) {
  //           disable = true
  //         }
  //         if (year == minYear) {
  //           if (month < minMonth) {
  //             disable = true
  //           }
  //           if (month == minMonth) {
  //             if ((d.value || 0) < minDate1) {
  //               disable = true
  //             }
  //           }
  //         }
  //       }
  //       if (maxDate) {
  //         if (year > maxYear) {
  //           disable = true
  //         }
  //         if (year == maxYear) {
  //           if (month > maxMonth) {
  //             disable = true
  //           }
  //           if (month == maxMonth) {
  //             if ((d.value || 0) > maxDate1) {
  //               disable = true
  //             }
  //           }
  //         }
  //       }
  //       d.disable = disable
  //     }
  //   })
  //   let current = new Date()
  //   if (month == current.getMonth() && year == current.getFullYear()) {
  //     let suggest = arr?.find(t => t.value == current.getDate())
  //     if (suggest && !suggest.disable) {
  //       suggest.isCurrent = true
  //     }
  //   }
  //   if (valueState && month == (valueState as Date).getMonth() && year == (valueState as Date).getFullYear()) {
  //     let active = arr?.find(t => t.value == (valueState as Date).getDate())
  //     if (active && !active.disable) {
  //       active.isActive = true
  //     }
  //   }
  //   setDates(arr)
  // }, [month, year, minDate, maxDate, date])

  useEffect(() => {
    let newArr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(t => ({
      disable: false,
      value: t,
      isActive: false,
      isCurrent: false
    }))
    let minYear = minDate?.getFullYear() || 0
    let minMonth = minDate?.getMonth() || 0

    let maxYear = maxDate?.getFullYear() || 0
    let maxMonth = maxDate?.getMonth() || 0
    newArr.forEach(m => {
      let disable = false
      if (minDate) {
        if (year < minYear) {
          disable = true
        }
        if (year == minYear) {
          if (m.value < minMonth) {
            disable = true
          }
        }
      }
      if (maxDate) {
        if (year > maxYear) {
          disable = true
        }
        if (year == maxYear) {
          if (m.value > maxMonth) {
            disable = true
          }
        }
      }
      m.disable = disable
    })

    let current = new Date()
    if (year == current.getFullYear()) {
      let suggest = newArr?.find(t => t.value == current.getMonth())
      if (suggest && !suggest.disable) {
        suggest.isCurrent = true
      }
    }
    if (valueState && year == (valueState as Date).getFullYear()) {
      let active = newArr?.find(t => t.value == (valueState as Date).getMonth())
      if (active && !active.disable) {
        active.isActive = true
      }
    }
    setMonths(newArr)
  }, [year, minDate, maxDate, valueState])

  useEffect(() => {
    const currentDate = new Date()
    let maxYear = currentDate.getFullYear() + 100
    if (maxDate) {
      maxYear = maxDate.getFullYear()
    }
    let minYear = currentDate.getFullYear() - 100
    if (minDate) {
      minYear = minDate.getFullYear()
    }
    let newYears = Array.from({ length: maxYear - minYear + 1 }, (_, i) => (minYear + i))
    setYears(newYears?.reverse())
  }, [minDate, maxDate])

  useEffect(() => {
    if (showYearPicker) {
      yearRef.current?.scrollIntoView({
        block: "center"
      })
    }
  }, [showYearPicker])


  const onClick = () => {
    if (!props.disabled) {
      if (valueState) {
        setMonth((valueState as Date).getMonth())
        setYear((valueState as Date).getFullYear())
      }
      else {
        let current = new Date()
        setMonth(current.getMonth())
        setYear(current.getFullYear())
      }
      setShowCalendar(true)
    }
  }

  const onClickBackdrop = () => {
    setShowCalendar(false)
  }
  const onClickClose = () => {
    setShowCalendar(false)
  }
  const onClickYearLabel = () => {
    setShowYearPicker(prev => !prev)
  }
  const onClickMonth = (e: any) => {
    let vlue = +e.target.innerText - 1
    if (!valueState || (valueState as Date).getMonth() != vlue || (valueState as Date).getFullYear() != year) {
      let newDate = new Date(year, vlue, 1)
      setValueState(newDate)
      onChange && onChange(newDate)
    }
    setShowCalendar(false)
  }
  const onClickYear = (e: any) => {
    let newYear = +e.target.innerText
    setYear(newYear)
    setShowYearPicker(false)
  }
  const onClickClear = () => {
    setValueState(null)
    setShowCalendar(false)
    onChange && onChange(null)
  }

  let text = ""
  let haveValue = false
  if (valueState) {
    text = NumberTool.convertToString((valueState as Date).getMonth() + 1, 2) + "/" + (valueState as Date).getFullYear()
    haveValue = true
  }
  const inputProps = {
    readOnly: true,
    onClick: onClick,
    value: text
  } as React.InputHTMLAttributes<HTMLInputElement>
  const clearButtonProps = {
    onClick: onClickClear,
    hidden: valueState ? false : true
  } as React.ButtonHTMLAttributes<HTMLButtonElement>
  return (
    <Fragment>
      {
        props.renderView(inputProps, clearButtonProps)
      }
      {
        showCalendar &&
        <Fragment>
          <div onClick={onClickBackdrop} className={style.backdrop}>
          </div>
          <div className={style.calendar}>
            <div className={style.head}>
              <div className={style.month_group}>
                <button type="button" className={style.month_label}>Tháng {month + 1}</button>
              </div>
              <button type="button" onClick={onClickYearLabel} className={style.year_label}>{year}</button>
            </div>
            <div className={style.body}>
              <div className={style.months}>
                {
                  months.map(m => {
                    return (
                      <button
                        type="button"
                        disabled={m.disable}
                        key={m.value}
                        className={StringTool.mergeClassName(style.month, m?.isActive ? style.active : "", m?.isCurrent ? style.current : "")}
                        onClick={onClickMonth}
                      >
                        {m.value + 1}
                      </button>
                    )
                  })
                }
              </div>
              {
                showYearPicker &&
                <div className={style.years}>
                  {
                    years?.map((yearValue, index) => {
                      let isActive = (yearValue == year)
                      return (
                        <button ref={isActive ? yearRef : null} type="button" key={yearValue} onClick={onClickYear} className={style.year}>{yearValue}</button>
                      )
                    })
                  }
                </div>
              }

            </div>
            <div className={style.actions}>
              {
                props.clearable && haveValue &&
                <button type="button" className={style.action} onClick={onClickClear}>Xóa</button>
              }
              <button type="button" className={StringTool.mergeClassName(style.action, style.close)} onClick={onClickClose}>Đóng</button>
            </div>
          </div>
        </Fragment>
      }
    </Fragment >
  )
}

export default MonthPicker;
